import { useEffect } from 'react'
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react'
import { useNavigate, useLocation } from 'react-router'
import { Logo } from '../../components/Logo/Logo'
import { FadeIn } from '../../components/FadeIn'
import { Col, Row } from 'antd'

export const LoginPage = () => {
  const { route } = useAuthenticator((context) => [context.route])
  const location = useLocation()
  const navigate = useNavigate()

  const from = location.state?.from?.pathname || '/home'

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, { replace: true })
    }
  }, [route, navigate, from])

  return (
    <FadeIn>
      <Col
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Row style={{ marginBottom: 36 }}>
          <Logo showText={false} width={132} height={128} />
        </Row>
        <Row>
          <Authenticator />
        </Row>
      </Col>
    </FadeIn>
  )
}
